module.exports = __webpack_public_path__ + "static/media/ticket-thankyou-bg.212124ec.svg";